import CustomReactSelect from './CustomReactSelect'

export default CustomReactSelect
